import Authentication from '@gwp-components/authentication';
import '@gwp-components/authentication/dist/main.css';


// Render your React component instead
const root = document.getElementById('gwp-auth-react-app');

if ( root ) {
    window.ReactDOM.render(<Authentication showLearnMoreLink={true} />, root);
}
